require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListAccordionGroupContext = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/List/ListAccordionGroup.tsx";
var ListAccordionGroupContext = React.createContext(null);
exports.ListAccordionGroupContext = ListAccordionGroupContext;

var ListAccordionGroup = function (_React$Component) {
  (0, _inherits2["default"])(ListAccordionGroup, _React$Component);

  function ListAccordionGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ListAccordionGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ListAccordionGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      expandedId: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAccordionPress", function (expandedId) {
      _this.setState(function (_ref) {
        var currentExpandedId = _ref.expandedId;
        return {
          expandedId: currentExpandedId === expandedId ? undefined : expandedId
        };
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(ListAccordionGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          expandedId = _this$props.expandedId,
          onAccordionPress = _this$props.onAccordionPress,
          children = _this$props.children;
      return React.createElement(ListAccordionGroupContext.Provider, {
        value: {
          expandedId: expandedId || this.state.expandedId,
          onAccordionPress: onAccordionPress || this.onAccordionPress
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        }
      }, children);
    }
  }]);
  return ListAccordionGroup;
}(React.Component);

(0, _defineProperty2["default"])(ListAccordionGroup, "displayName", 'List.AccordionGroup');
var _default = ListAccordionGroup;
exports["default"] = _default;